import { useState } from 'react';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

interface IChartTabsProps {
  tabs: ITab[];
  onChange: (value: string) => void;
}

export const ChartTabs = ({ tabs, onChange }: IChartTabsProps) => {
  const [value, setValue] = useState(tabs[0].value);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    onChange(newValue);
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          {tabs.length > 1 && (
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              {tabs.map((tab) => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  sx={(theme) => ({
                    textTransform: 'none',
                    fontSize: theme.typography.body1.fontSize,
                    fontWeight: 400,
                    '&.Mui-selected': {
                      fontWeight: 500,
                      color: theme.palette.secondary.main,
                    },
                  })}
                />
              ))}
            </TabList>
          )}
        </Box>
        {tabs.map((tab) => (
          <TabPanel key={tab.value} value={tab.value}>
            {tab.content}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};

interface ITab {
  label: string;
  value: string;
  content: React.ReactNode;
}
